import type { ReactNode } from 'react'
import { Navigate } from 'react-router'

import { getToken } from '@/lib/api'

/** Bounces an already-signed-in admin away from the login screen. */
export function RedirectIfAuthenticated({ children }: { children: ReactNode }) {
  if (getToken()) return <Navigate to="/" replace />
  return <>{children}</>
}

/**
 * Gate for every signed-in route. This only checks that a token exists — it
 * does not validate it. An expired/invalid token is caught by the 401
 * handler in lib/queryClient.ts on the first request.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  if (!getToken()) return <Navigate to="/login" replace />
  return <>{children}</>
}
